import React from "react";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "../ui/sidebar";
import { Button } from "../ui/button";
import { Separator } from "../ui/separator";
import { Plus } from "lucide-react";
import { Skeleton } from "../ui/skeleton";

const SkeletonLoader = () => {
  const { open } = useSidebar();
  return (
    <div className="flex h-screen w-full">
      <Sidebar collapsible="icon">
        {open && (
          <SidebarHeader className="p-4">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Pages</h2>
            </div>
          </SidebarHeader>
        )}

        <SidebarContent className={open ? "p-4" : "p-2"}>
          {open && <Separator className="mb-4" />}
          <div className="flex flex-col gap-2">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </div>
        </SidebarContent>
      </Sidebar>
      <div className="flex items-center flex-col flex-1 pt-8 gap-8 p-6">
        <div className="grid grid-cols-4 gap-8 max-w-6xl w-full">
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
        </div>
        <div className="grid grid-cols-4 gap-8 max-w-6xl w-full">
          <Skeleton className="h-60 col-span-2" />
          <Skeleton className="h-60 col-span-2" />
        </div>
        <div className="grid grid-cols-4 gap-8 max-w-6xl w-full">
          <Skeleton className="h-60 col-span-4" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
